module.exports = __webpack_public_path__ + "img/spm_team.f4eb9371.jpg";